// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Rating } from 'react-simple-star-rating';
// import { FaArrowRight } from 'react-icons/fa';

// const InfoFeedback = ({ tripId, isRated, currentRating, serviceType }) => {
//   const navigate = useNavigate();

//   const navigateToFeedback = () => {
//     console.log('navigateToFeedback Clicked');
//     navigate('/feedback', { state: { tripId, serviceType } });
//   };

//   return (
//     <div
//     className={`flex justify-between w-full p-4 mt-2 mb-2 bg-white shadow-md rounded-lg  ${ isRated ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-lg'
//       // className={`flex justify-between items-center p-4 m-2 border rounded-lg cursor-pointer 
       
//       }`}
//       onClick={!isRated ? navigateToFeedback : undefined}
//     >
//       <div className="flex items-center space-x-3">
//         <p className="text-lg font-semibold">
//           {isRated ? 'Your rating for this trip' : 'Rate this trip'}
//         </p>

//         {/* Added flex items-center to ensure horizontal alignment */}
//         <div className="flex items-center space-x-1">
//           <Rating 
//             initialValue={currentRating} 
//             readonly 
//             size={25} 
//             className="flex"  // Add flex to Rating container
//             SVGstyle={{ display: 'inline-block' }}  // Ensure SVG elements are inline
//           />
//           <p className="text-lg font-semibold">{currentRating}</p>
//         </div>
//       </div>

//       {!isRated && <FaArrowRight className="text-xl text-gray-700" />}
//     </div>
//   );
// };

// export default InfoFeedback;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Rating } from 'react-simple-star-rating';
import { FaArrowRight } from 'react-icons/fa';
import TripServices from '../../../services/externalServices/trip/TripServices';
import { useSelector } from 'react-redux';

const InfoFeedback = ({ tripId, isRated, currentRating, serviceType }) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(currentRating);
  const [isEditing, setIsEditing] = useState(false);
  const user = useSelector((state) => state.user.user);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  console.log("isRated",isRated)
  const submitRating = async () => {
    console.log('Submitting rating:', rating);
    
    try {
      const response = await TripServices.getRiderAverageRatingCount({
        rating,
        id: tripId,
        auth: user,
      });

      if (response.success) {
        alert('Rating updated successfully');
        setIsEditing(false);  // Exit editing mode
      } else {
        alert('Failed to update rating');
      }
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      alert('Something went wrong!');
    }
  };

  const toggleEdit = () => {
    if (!isRated) {
      setIsEditing(!isEditing);
    }
  };

  return (
    <div
      className={`flex justify-between w-full p-4 mt-2 mb-2 bg-white shadow-md rounded-lg ${
        isRated ? 'opacity-50' : 'hover:shadow-lg cursor-pointer'
      }`}
    >
      <div className="flex items-center space-x-3">
        <p className="text-lg font-semibold">
          {isRated ? 'Your rating for this trip' : 'Rate this trip'}
        </p>

        <div className="flex items-center space-x-1">
          <Rating
            initialValue={rating}
            onClick={handleRatingChange}
            size={25}
            allowHover={!isRated}
            readonly={isRated}
            transition
            className="flex"
            SVGstyle={{ display: 'inline-block' }}
          />
          <p className="text-lg font-semibold">{rating}</p>
        </div>
      </div>

      <div className="flex items-center space-x-3">
        {!isRated && isEditing && (
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
            onClick={submitRating}
          >
            Submit Rating
          </button>
        )}

        {!isRated && !isEditing && (
          <FaArrowRight 
            className="text-xl text-gray-700 cursor-pointer"
            onClick={toggleEdit}
          />
        )}
      </div>
    </div>
  );
};

export default InfoFeedback;
